import React, { useState, useRef, useEffect } from "react";
import styles from "./dropdown.module.scss";

interface DropdownProps {
  id: string;
  default_value: string;
  optionsArray: string[];
  click: (value: string) => void;
}

const Dropdown: React.FC<DropdownProps> = ({
  id,
  default_value,
  optionsArray,
  click,
}) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(default_value);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option: string) => {
    setSelected(option);
    setOpen(false);
    click(option);
  };

  return (
    <div className={styles.dropdownWrapper} ref={dropdownRef}>
      <div
        id={id}
        data-testid={id}
        className={styles.dropdownButton}
        onClick={() => setOpen((prev) => !prev)}
      >
        {selected} <span className={styles.dropdownArrow}>▾</span>
      </div>

      {open && (
        <div className={styles.dropdownMenu} data-testid={`${id}-menu`}>
          {optionsArray.map((option) => {
            const optionId = `${id}-option-${option
              .toLowerCase()
              .split(" ")
              .join("-")}`;
            return (
              <div
                key={option}
                id={optionId}
                data-testid={optionId}
                className={`${styles.dropdownItem} ${
                  option === selected ? styles.active : ""
                }`}
                onClick={() => handleSelect(option)}
              >
                {option}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
